import $http from '@/libs/axios'

// Item reservation slot payload
export interface ItemReservationSlotPayload {
  start_time: string;
  end_time: string;
  is_active: boolean;
  price: number;
  id?: number;
}

export interface ItemReservationAdvancePayload {
  interval: number | string;
  scale: 'min' | 'hour' | 'day';
}

export interface ItemReservationItemPayload {
  reservation_min_advance: string;
  reservation_max_advance: string;
  min_advance: ItemReservationAdvancePayload;
  max_advance: ItemReservationAdvancePayload;
  quantity: number | null;
  availability?: number;
  reservation_slots: ItemReservationSlotPayload[];
  deleted_slots: number[];
}

export type ProductReservationStatusCode = 0 | 1 | 2 | 3

export default class ProductReservationsAPI {
  static async getSettings(branchId: number) {
    return (await $http.get(`/reservations/settings/${branchId}`)).data
  }

  static async updateProductReservationStatus(
    branchId: number,
    orderLineId: number,
    reservationStatus: ProductReservationStatusCode,
  ) {
    return (
      await $http.put(`/reservations/order-lines/${branchId}/${orderLineId}`, {
        reservation_status: reservationStatus,
      })
    ).data
  }
}
